<script setup>
const props = defineProps({
  text: {
    type: String,
    default: ''
  }
})
</script>

<template>
  <p v-if="props.text" class="text-[11px] text-slate-400 mt-1">
    {{ props.text }}
  </p>
</template>
